import React from 'react';
import { BrowserRouter } from 'react-router-dom';

import { LoginRoutes } from '@/routes';

export default function App() {
  return (
    <BrowserRouter>
      <LoginRoutes />
    </BrowserRouter>
  );
}
